import { useMemo } from 'react';

import { escapeRegex } from '../../../utils/escape-regex';

/**
 * Calculate highlight pattern for displaying matches in the dropdown
 * Creates a RegExp for highlighting matching text or uses custom pattern function
 */
export const useHighlightPattern = ({
  autoCompleteBehavior,
  isDirty,
  getHighlightPattern,
  inputValue,
}: {
  autoCompleteBehavior: 'none' | 'manual' | 'automatic';
  isDirty: boolean;
  getHighlightPattern?: ((value: string) => string | RegExp) | null;
  inputValue: string;
}) =>
  useMemo(() => {
    if (autoCompleteBehavior === 'none') {
      return null;
    }

    if (typeof getHighlightPattern === 'function') {
      return getHighlightPattern(inputValue);
    }

    const trimmed = inputValue.trim();
    return isDirty && trimmed ? new RegExp(`\\b${escapeRegex(trimmed)}`, 'ig') : null;
  }, [isDirty, inputValue, getHighlightPattern, autoCompleteBehavior]);
